import { Instagram, Twitter, Youtube } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16">
        {/* Top grid */}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 mb-20">
          <div className="col-span-2 md:col-span-5">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#155E63] font-bold">
              Aevum, Vol. I
            </p>
            <p className="mt-4 font-display text-2xl text-[#F5F2EA] leading-snug max-w-sm">
              An athletic house for the unending self.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-4">
              House
            </p>
            <ul className="space-y-3 text-sm text-[#F5F2EA]/80">
              <li>
                <a
                  href="#ethos"
                  data-testid="footer-link-ethos"
                  className="hover:text-[#155E63] transition-colors"
                >
                  Ethos
                </a>
              </li>
              <li>
                <a
                  href="#manifesto"
                  data-testid="footer-link-manifesto"
                  className="hover:text-[#155E63] transition-colors"
                >
                  Manifesto
                </a>
              </li>
              <li>
                <a
                  href="#newsletter"
                  data-testid="footer-link-newsletter"
                  className="hover:text-[#155E63] transition-colors"
                >
                  The Letter
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-4">
              Follow the long arc
            </p>
            <div className="flex items-center gap-5">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid="social-instagram"
                aria-label="Instagram"
                className="text-[#F5F2EA]/70 hover:text-[#155E63] transition-colors"
              >
                <Instagram size={20} strokeWidth={1.4} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                data-testid="social-twitter"
                aria-label="Twitter / X"
                className="text-[#F5F2EA]/70 hover:text-[#155E63] transition-colors"
              >
                <Twitter size={20} strokeWidth={1.4} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                data-testid="social-youtube"
                aria-label="YouTube"
                className="text-[#F5F2EA]/70 hover:text-[#155E63] transition-colors"
              >
                <Youtube size={20} strokeWidth={1.4} />
              </a>
            </div>
            <p className="mt-6 text-xs text-[#A3A3A3] leading-relaxed max-w-xs">
              Aevum is independent. Made for runners, lifters, climbers,
              swimmers, and the quietly persistent.
            </p>
          </div>
        </div>

        {/* Massive logotype */}
        <div className="border-t border-white/10 pt-12 pb-6">
          <h3
            data-testid="footer-logotype"
            className="font-display font-semibold text-[28vw] leading-[0.8] tracking-tighter text-[#F5F2EA]/95 select-none"
          >
            AEVUM
          </h3>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-6 text-[11px] tracking-[0.25em] uppercase text-[#A3A3A3]">
          <p>© {year} Aevum — Endless Time</p>
          <p>Designed slowly. Worn forever.</p>
        </div>
      </div>
    </footer>
  );
}
